import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import DeptLeft from '../People/Dept_Left'

const HD = [
    {
        "Name": "Dr. Chandra Sekhar Bahinipati",
        "NameLink": "/dr-chandra-sekhar-bahinipati",
        "Position": "Associate Professor",
        "Category": "Head of the Department",
        "Degree": "Ph.D. (Economics) - Madras Institute of Development Studies, Chennai, India",
        "AreasofInterest": "Climate Change Economics",
        "Phone": "0877 2503306",
        "Email": "hod_hss@iittp.ac.in / csbahinipati@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/chandrabahinipati.jpg"
    }
   
]
const Faculty = [



    {
        "Name": "Dr. A Raghuramaraju",
        "NameLink": "https://iittp.ac.in/dr-a-raghuramaraju",
        "Position": "Professor",
        "Degree": "Ph.D - IIT Kanpur, India",
        "AreasofInterest": "Social and Political Philosophy",
        "Phone": "0877 2503308",
        "Email": "raghuramaraju@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/raghuramaraju.jpg"
    },
    {
        "Name": "Dr. Bharath Kumar",
        "NameLink": "/dr-bharath-kumar",
        "Position": "Associate Professor",
        "Degree": "Ph.D - University of Hyderabad, India",
        "AreasofInterest": "Social and Political Philosophy, Contemporary Indian Thought",
        "Phone": "0877 2503305",
        "Email": "bharathk@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/BharathKumar.jpg"
    },
    
    {
        "Name": "Dr. Prabha Shankar Dwivedi",
        "NameLink": "https://iittp.ac.in/dr-prabha-shankar-dwivedi",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Dr. H. S. Gour Central University, Sagar,  ",
        "AreasofInterest": "English and Comparative Literary Studies, Indian Aesthetics and Poetics",
        "Phone": "0877 250 3307 ",
        "Email": "prabhas.dwivedi@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prabha.jpg"
    },
    {
        "Name": "Dr. Rahul A. Sirohi",
        "NameLink": "/dr-rahul-a-sirohi",
        "Position": "Associate Professor",
        "Degree": "Ph.D Economics - University of Illinois at Urbana Champaign",
        "AreasofInterest": "Development Economics",
        "Phone": "0877 2503309",
        "Email": "rahul.sirohi@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Sirohi.jpg"
    },
    {
        "Name": "Dr. Arvind Kumar Pandey",
        "NameLink": "/dr-arvind-kumar-pandey",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Jawaharlal Nehru University (JNU), New Delhi, India.",
        "AreasofInterest": "Urban Planning and Policies, Urban Identities and Governance",
        "Email": "arvind.pandey@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Arvind_Kumar_Pandey_AP.png"
    },
    {
        "Name": "Dr. Bibhuti Mary Kachhap",
        "NameLink": "/dr-bibhuti-mary-kachhap",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology (ISM), Dhanbad, India",
        "AreasofInterest": "South Asian Literature and Cultural Studies",
        "Email": "bibhuti@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/mary.jpg"
    },
    {
        "Name": "Dr. Samyukta Bhupatiraju",
        "NameLink": "/dr-samyukta-bhupatiraju",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Economics and Technical Change, United Nations University – MERIT and Maastricht University",
        "AreasofInterest": "Financial Economics and Financial Inclusion, Development Economics",
        "Phone": " ",
        "Email": "samyukta.bhupatiraju@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Samyukta_Bhupatiraju_AP_HSS.png"
    },
   
    // {
    //     "Name": "Dr. Sanchayan Nath",
    //     "NameLink": "https://iittp.ac.in/dr-sanchayan-nath",
    //     "Position": "Assistant Professor",
    //     "Degree": "Ph.D - Indiana University Bloomington, USA",
    //     "AreasofInterest": "Sustainability, Public Policy and Governance",
    //     "Phone": "8977931775",
    //     "Email": "sanchayan@iittp.ac.in",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/Sanchayan Nath.jpg"
    // },
    {
        "Name": "Dr. Shailendra Kumar Singh",
        "NameLink": "https://iittp.ac.in/dr-shailendra-kumar-singh",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Jamia Millia Islamia, New Delhi, India",
        "AreasofInterest": "South Asian Narratives, Gender Studies",
        "Email": "shailendra@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr. Shailendra Singh.jpg"
    },
    {
        "Name": "Dr. Vaneet Kashyap",
        "NameLink": "/dr-vaneet-kashyap",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology, Roorkee, India",
        "AreasofInterest": "Industrial and Organizational Psychology, Organizational Behaviour",
        "Phone": "0877 2503312",
        "Email": "vaneet.kashyap@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/vaneet-kashyap.jpg"
    },
    {
        "Name": "Dr. Varun Varghese",
        "NameLink": "/dr-varun-varghese",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Bombay, Mumbai, India.",
        "AreasofInterest": "Urban and Transportation Planning, Behavioural Analysis",
        "Phone": "8879046608",
        "Email": "varunv@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Varun_AP.png"
    },
    {
        "Name": "Dr. Vishnu C. Rajan",
        "NameLink": "https://iittp.ac.in/dr-vishnu-c-rajan",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - National Institute of Technology Calicut (NITC), India",
        "AreasofInterest": "Operations Management, Industrial Engineering",
        "Phone": "9526373908",
        "Email": "vishnu@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Vishnu_C_Rajan.jpg"
    }




]


const GuestFaculty = [


    {
        "Name": "Dr. Arniker Hamsa",
        "NameLink": "#",
        "Position": "",
        "Degree": "Ph.D - SV University, Tirupati, India",
        "AreasofInterest": "German",
        "Phone": "+91 - 9963352358",
        "Email": "arnikerhamsa@gmail.com",
        "Image": "https://files.iittp.ac.in/images/demo/iit/hamsa.jpg"
    },
    {
        "Name": "Dr. O.G.P. Kalyana Sastry",
        "NameLink": "#",
        "Position": "",
        "Degree": "Ph.D - Navya Nyaya from Rashtriya Sanskrit Vidyapeetha, Tirupati, Andhra Pradesh",
        "AreasofInterest": "Navya Nyaya, Sabdabodha, Computational Linguistics",
        "Phone": "",
        "Email": "",
        "Image": "https://files.iittp.ac.in/images/demo/iit/kal.jpg"
    }


]

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="HUMANITIES AND SOCIAL SCIENCES" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> People
                                </h5>
                                <h3>HUMANITIES AND SOCIAL SCIENCES</h3>
                            </div>
                        </div>
                    </div>


                    <Row>
                        <Col md={3} className='c-left custom-padding-color mb-4'>
                            <DeptLeft activeIndex={6} />
                        </Col>
                        <Col md={9} className='c-right'>

                            {/*--------------------------- Head of the dept */}

                            <div className="row justify-content-center">
                                <h3 className='c-headline mt-5 mb-5'>Head of the Department</h3>
                                {HD.map((HD, index) => (
                                    <div key={index} className="col-xl-5 col-md-6--">
                                        {/* 
                                {index === 0 || HD.Category !== HD[index - 1].Category ? (
                                    <div>
                                        <h5 className="font-weight-bold text-teal">{HD.Category}</h5>
                                        <hr/> <br/>
                                    </div>
                                ) : null} */}

                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={HD.NameLink}>
                                                        <img src={HD.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={HD.NameLink}>{HD.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{HD.Position}</p>
                                                    <p className="text-dark">{HD.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {HD.AreasofInterest}</p>

                                                    {(HD.Phone !== undefined && HD.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{HD.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {HD.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*--------------------------- Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Faculty</h3>
                                {Faculty.map((Faculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{Faculty.Position}</p>
                                                    <p className="text-dark">{Faculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {Faculty.AreasofInterest}</p>

                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {Faculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>





                            {/*--------------------------- Guest Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Guest Faculty</h3>
                                {GuestFaculty.map((GuestFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={GuestFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={GuestFaculty.NameLink}>{GuestFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    {(GuestFaculty.Position !== undefined && GuestFaculty.Position !== "") && (
                                                        <p > <i className="fal fa-graduation-cap me-2" />{GuestFaculty.Position}</p>
                                                    )}
                                                    
                                                    <p className="text-dark">{GuestFaculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest</b>: {GuestFaculty.AreasofInterest}</p>

                                                    {(GuestFaculty.Phone !== undefined && GuestFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{GuestFaculty.Phone}</p>
                                                    )}
                                                    {(GuestFaculty.Email !== undefined && GuestFaculty.Email !== "") && (
                                                        <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {GuestFaculty.Email}</p>
                                                    )}
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </Col>
                    </Row>

                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main